import { render, staticRenderFns } from "./fnf.vue?vue&type=template&id=88c2cd68&scoped=true"
import script from "./fnf.vue?vue&type=script&lang=js"
export * from "./fnf.vue?vue&type=script&lang=js"
import style0 from "./fnf.vue?vue&type=style&index=0&id=88c2cd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c2cd68",
  null
  
)

export default component.exports